export const MFA_SETUP_LATER_FORM = 'MFA_SETUP_LATER_FORM';
export const MFA_SETUP_LATER_MODAL = 'MFA_SETUP_LATER_MODAL';
